import FPGAnimator from './FPGAnimator';
export default FPGAnimator;
